import { useSession } from 'contexts/session';
import { useEffect, useState } from 'react';
import { Permissions } from 'utils/permission';

export function usePermission() {
  const [session] = useSession();
  const [permission, setPermission] = useState<Permissions>();

  useEffect(() => {
    if (session?.user) {
      setPermission(new Permissions(session?.user));
    }
  }, [session]);

  return permission;
}
